import { axios } from "@/lib/axios";
import { ClassInviteData } from '@/features/Classes/types';

export const sendInvite = async (classId: number, data: ClassInviteData) => {
    return axios.post(`api/admin/class/${classId}/invite`, data);
};